/** Titles and subtitles for Q Value module list pages (sidebar labels + short descriptions). */
export const Q_VALUE_PAGE_HEADERS = {
    incoming_master: {
        title: 'In-Coming Master',
        subtitle: 'Maintain part numbers, suppliers, and inspection requirements for incoming material.',
    },
    inprogress_master: {
        title: 'In-Progress Master',
        subtitle: 'Maintain in-process inspection requirements and part definitions for production.',
    },
    outgoing_master: {
        title: 'Outgoing Master',
        subtitle: 'Maintain outgoing inspection requirements and customer part data.',
    },
    fai_master: {
        title: 'FAI Master',
        subtitle: 'Maintain first article inspection requirements and part master data.',
    },
    incoming_summary: {
        title: 'In-Coming Summary Report',
        subtitle: 'Review, search, and approve incoming inspection reports.',
    },
    inprogress_summary: {
        title: 'In-Progress Summary Report',
        subtitle: 'Review and approve in-process inspection and production quality records.',
    },
    outgoing_summary: {
        title: 'Out-Going Summary Report',
        subtitle: 'Review and approve outgoing shipment inspection reports.',
    },
    fpbo_summary: {
        title: 'FPBO Summary Report',
        subtitle: 'Review first piece buy-off records and approval status.',
    },
    lpbo_summary: {
        title: 'LPBO Summary Report',
        subtitle: 'Review last piece buy-off records and approval status.',
    },
    fai_summary: {
        title: 'FAI Summary Report',
        subtitle: 'Review first article inspection summaries and approvals.',
    },
    waiting_for_inspection: {
        title: 'Waiting for Inspection',
        subtitle: 'FPBO, LPBO, and FAI records submitted and pending QC inspection.',
    },
    inspection_list: {
        title: 'Inspection Requirement List',
        subtitle: 'Manage reusable incoming inspection requirement definitions.',
    },
    test_list: {
        title: 'Test Requirement List',
        subtitle: 'Manage reusable test requirement definitions for QC masters.',
    },
    defect_category: {
        title: 'Master Defect Category Matrix',
        subtitle: 'Process category with manual defect types, optional severity, and physical indication.',
    },
    corrective_action_report: {
        title: 'CAR Summary Tracker',
        subtitle: 'Track corrective actions, owners, target dates, and closure status.',
    },
    eight_d_report: {
        title: '8D Summary Tracker',
        subtitle: 'Track 8D reports; target and closed dates follow D6 on each report.',
    },
};

/** CAR / 8D create-edit forms — document number stays in the form, not the page header. */
export function getQValueReportTrackerFormHeader(pageKey, { isNew } = {}) {
    const meta = Q_VALUE_PAGE_HEADERS[pageKey];
    if (!meta) {
        return { title: isNew ? 'New report' : 'Edit report', subtitle: '' };
    }
    const title = `${meta.title} — ${isNew ? 'New' : 'Edit'}`;
    const subtitle = isNew
        ? `Create a new report. ${meta.subtitle}`
        : meta.subtitle;
    return { title, subtitle };
}

/** Master create/edit full-page forms (Q Value). */
export function getQValueMasterFormHeader(pageKey, { isNew, partNo } = {}) {
    const meta = Q_VALUE_PAGE_HEADERS[pageKey];
    if (!meta) {
        return { title: isNew ? 'New record' : 'Edit record', subtitle: '' };
    }
    const title = `${meta.title} — ${isNew ? 'New' : 'Edit'}`;
    let subtitle = meta.subtitle;
    if (!isNew && partNo) {
        subtitle = `Part no: ${partNo}. ${meta.subtitle}`;
    } else if (isNew) {
        subtitle = `Create a new master record. ${meta.subtitle}`;
    }
    return { title, subtitle };
}

/** Summary / inspection report detail pages. */
export function getQValueReportHeader(pageKey, { readOnly, executionNo, workOrder } = {}) {
    const meta = Q_VALUE_PAGE_HEADERS[pageKey];
    const baseTitle = meta ? meta.title : 'QC Report';
    const title = readOnly
        ? `${baseTitle} — QC Inspection`
        : baseTitle;
    const parts = [];
    if (executionNo) {
        parts.push(`Report no: ${executionNo}`);
    }
    if (workOrder) {
        parts.push(`Work order: ${workOrder}`);
    }
    const detail = parts.length ? `${parts.join(' · ')}.` : '';
    const subtitle = readOnly
        ? `${detail} Review and complete inspection.`.trim()
        : `${detail} ${meta ? meta.subtitle : ''}`.trim();
    return { title, subtitle: subtitle || undefined };
}
